import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "../TradeChart/TradeChart.css";

const TradeChart = () => {
  const options = {
    chart: {
      zooming: {
        type: "xy",
      },
    },
    title: {
      text: "Karasjok weather, 2023",
      align: "left",
    },
    xAxis: [
      {
        categories: [
          "2022-01",
          "2022-07",
          "2023-01",
          "2023-07",
          "2024-01",
          "2024-02",
          "2024-03",
          "2024-04",
          "2024-05",
          "2024-06",
          "2024-07",
          "2024-08",
        ],
        crosshair: true,
      },
    ],
    yAxis: [
      {
        // Primary yAxis (for Guru Trades)
        labels: {
          format: "{value}",
        },
        title: {
          text: "Guru Trade",
        },
      },
      {
        // Secondary yAxis (for Price)
        title: {
          text: "Price",
        },
        labels: {
          format: "{value}", // Remove the 'mm' and just show the value
        },
        opposite: true,
      },
      {
        // Tertiary yAxis (for Guru Sells) - Hide this axis but still show in tooltip
        title: {
          text: "Guru Sells",
          style: {
            color: "#FF0000", // Red color for Guru Sells
          },
        },
        labels: {
          format: "{value}",
          style: {
            color: "#FF0000", // Red color for Guru Sells
          },
        },
        opposite: true,
        visible: false, // Hide the Guru Sells axis
      },
    ],
    
    tooltip: {
      shared: true,
      formatter: function () {
        let tooltip = "<b>" + this.x + "</b><br>";
        this.points.forEach(function (point) {
          tooltip += point.series.name + ": " + point.y + "<br>";
        });
        return tooltip;
      },
    },
    legend: {
      layout: "horizontal", // Arrange the legend items horizontally
      align: "center", // Center align the legend items
      verticalAlign: "top", // Align items vertically at the top
      backgroundColor:
        Highcharts.defaultOptions.legend.backgroundColor || // theme
        "rgba(255,255,255,0.25)",
      itemSpacing: 40, // Space between legend items horizontally
      itemMarginTop: 5, // Space above each legend item
      itemMarginBottom: 5, // Space below each legend item
      // You can use this to ensure the legend stretches evenly across the container
      x: 0, // Adjust horizontal position
      y: 0, // Adjust vertical position
      width: "100%", // Makes the legend take up full width for even distribution
      maxHeight: 100, // Set a maximum height if needed
    },

    series: [
      {
        name: "Number of Guru buys",
        type: "column",
        yAxis: 1,
        data: [5, 10, 15, 20, 25, 30, 35, 40, 50, 55, 60, 65],
        color: "#58a65c", // Set bar color to #58a65c
      },
      {
        name: "Number of Guru Sells",
        type: "column",
        yAxis: 2, // Use the third yAxis (hidden one)
        data: [
          5,
          12,
          7,
          15,
          8,
          10,
          6,
          14,
          9,
          11,
          13,
          9, // Example data for Guru Sells
        ],
        color: "#d85140", // Set bar color to red
      },
      {
        name: "Price",
        type: "spline",
        data: [11, 9, 14, 2, 7, 12, 13, 13, 8, 8, 12, 15],
        color: "#5383ec", // Set line color to #58a65c
      },
    ],
  };

  return (
    <div className="trade-container">
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default TradeChart;
